import { baseUrl } from '../../services/Apis';
import {
  ACTIVO_ARCHIVOS,
  ALERT_FORM_ARCHIVOS,
  ALERT_VIEW_ARCHIVOS,
  ALL_ARCHIVOS,
  LOADING_ALL_ARCHIVOS,
} from './ArchivosReducer';
import {
  ARCHIVOS_CONST,
  allArchivosService,
  deleteArchivosService,
  fileArchivosService,
  oneArchivosService,
  saveArchivosService,
} from './ArchivosService';

export const allArchivosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ARCHIVOS, payload: true });
    const res = await allArchivosService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_ARCHIVOS, payload: res.data });
      dispatch({ type: LOADING_ALL_ARCHIVOS, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_ARCHIVOS, payload: false });
    return null;
  } catch (e) {
    alertArchivos(dispatch, ALERT_VIEW_ARCHIVOS, {
      severity: 'warning',
      title: e.message,
    });
  }
};

export const saveArchivosAction = async (dispatch, data) => {
  try {
    const res = await saveArchivosService(data);
    const success = res.status >= 200 && res.status < 203;
    if (success) {
      alertArchivos(dispatch, ALERT_FORM_ARCHIVOS, {
        severity: 'success',
        title: res.data.message,
      });
      return res.data.data;
    } else {
      alertArchivos(dispatch, ALERT_FORM_ARCHIVOS, {
        severity: 'error',
        title: 'Error al momento de registrar el archivo',
      });
      return success;
    }
  } catch (e) {
    alertArchivos(dispatch, ALERT_FORM_ARCHIVOS, {
      severity: 'error',
      title: e.response?.data.message ?? e.message,
    });
  }
};

export const setActivoArchivosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ARCHIVOS, payload: data });
};

export const oneArchivosAction = async (dispatch, id) => {
  const res = await oneArchivosService(id);
  if (res.status === 200) {
    await setActivoArchivosAction(dispatch, res.data.data);
    return true;
  }
  return false;
};

export const alertArchivos = (dispatch, type, payload) => {
  dispatch({ type, payload });
  setTimeout(() => {
    dispatch({ type, payload: null });
  }, 4500);
};

export const deleteArchivosAction = async (
  dispatch,
  id,
  params,
  setLoadingDelete,
) => {
  try {
    setLoadingDelete(true);
    const res = await deleteArchivosService(id);
    if (res.status === 200) {
      await setActivoArchivosAction(dispatch, null);
      setLoadingDelete(false);
      await allArchivosAction(dispatch, params);
      alertArchivos(dispatch, ALERT_VIEW_ARCHIVOS, {
        severity: 'success',
        title: res.data.message ?? 'Materia eliminada exitosamente',
      });
      return true;
    }
    setLoadingDelete(false);
    alertArchivos(dispatch, ALERT_VIEW_ARCHIVOS, {
      severity: 'error',
      title: res.data.message ?? 'Error al momento de eliminar el archivo',
    });
    return false;
  } catch (e) {
    setLoadingDelete(false);
    alertArchivos(dispatch, ALERT_VIEW_ARCHIVOS, {
      severity: 'error',
      title: e.response?.data.message ?? e.message,
    });
  }
};

export const getFileUrl = (file) => {
  return file
    ? `${baseUrl}/${ARCHIVOS_CONST}/${file.folder}/public/${file.nombre}`
    : null;
};

export const getFileUrlAction = async (ruta, nameFile) => {
  const res = await fileArchivosService(ruta);

  // Crear un objeto URL a partir del Blob
  const url = window.URL.createObjectURL(new Blob([res.data]));

  // Crear un enlace oculto
  const link = document.createElement('a');
  link.href = url;

  // Sugerir un nombre de archivo para la descarga
  link.setAttribute('download', nameFile); // Cambia 'file.pdf' por el nombre de archivo que desees

  // Agregar el enlace al documento y hacer clic en él
  document.body.appendChild(link);
  link.click();

  // Limpiar después de la descarga
  document.body.removeChild(link);
};
